import ColoredHeader from '../../../common/components/layout/ColoredHeader';
import {Alert, Col, Container, Row} from 'reactstrap';
import Panel from '../../../common/components/Panel';
import {dateFormatFR} from '../../../utils';
import {Modal} from 'react-bootstrap';
import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {useTranslation, withTranslation} from 'react-i18next';
import {withLoadedUser} from '../../../login/containers/AuthBase';
import {flowRight as compose} from 'lodash';
import config from '../../../config/app';
import Image from '../../../common/components/Image';
import {
  CancelButton, DeleteLogoButton, FileDiv, FileInput,
  FileLabel,
  FileNameDiv,
  FooterRow,
  GradientCol, LoadingContainer,
  TitleButton,
} from '../../../common/components/StyledComp';
import Error from '../../../common/components/Error/Error';
import {Mutation} from 'react-apollo';
import {PulseLoader} from 'react-spinners';
import gql from 'graphql-tag';
import DateRangePicker from '../../../common/components/Dates/DateRangePicker';
import isBeforeDay from 'react-dates/lib/utils/isBeforeDay';
import moment from 'moment';
import {
  CAMPAIGN_PICTURE_HEIGHT,
  CAMPAIGN_PICTURE_WIDTH,
  CAMPAIGN_STATUS,
  IMAGE_MIME_TYPES,
  MAX_CAMPAIGN_CONTENT_LENGTH,
  MAX_CAMPAIGN_TITLE_LENGTH,
} from '../../../common/constants';
import Tooltip from '../../../common/components/Tooltip';
import Input from 'reactstrap/lib/Input';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimes} from '@fortawesome/free-solid-svg-icons';

export const GRAPHQL_MUTATION_UPDATE_CAMPAIGN = gql`
  mutation updateCampaign($campaignInput: UpdateCampaignInput!) {
    updateCampaign(campaignInput: $campaignInput) {
      id
      status
      title
      content
      link
      startDate
      endDate
      filterUserStartDate
      filterUserEndDate
      filterUserCivility
      totalUsers
      totalUsersWithLoyaltyCard
      totalUsersWithoutLoyaltyCard
      createdAt
      updatedAt
      file {
        id
        token
        filename
        mimeType
      }
    }
  }
`;
const MargedContainer = styled(Container)`
  margin-bottom: 10px;
`;

const ModalHeader = styled(Modal.Header)`
  && {
    padding: 0;
    border-bottom: 0;
  }
`;
const ImageCampaign = styled(Image)`
  width: 100%;
  object-fit: contain;
  max-width: 400px;
  border-radius: 20px;
`;

const AttributeDiv = styled.div`
  text-transform: uppercase;
  font-family: 'Segoe UI Bold', sans-serif;
  margin-top: 15px;
  margin-bottom: 5px;
`;

const MargedAlert = styled(Alert)`
  margin-top: 10px;
`;

const CampaignDetailsModal = ({t, campaign, showModal, changeModalState, editable}) => {

  const [submitted, setSubmitted] = useState(false);
  const [fileName, setFileName] = useState(campaign.file ? campaign.file.filename : '');
  const [wrongFormat, setWrongFormat] = useState(false);
  const [wrongURL, setWrongUrl] = useState(false);
  const [{startDate, endDate}, setDateFilter] = useState({
    startDate: moment(campaign.startDate),
    endDate: moment(campaign.endDate),
  });
  const [campaignUpdate, setCampaignUpdate] = useState({
    id: campaign.id,
    title: campaign.title,
    deleteFile: false,
    updateFile: null,
    deleteContent: false,
    updateContent: campaign.content,
    deleteLink: false,
    updateLink: campaign.link,
  });

  const {t: userT} = useTranslation('user');

  useEffect(() => {
    if (showModal) {
      setSubmitted(false);
      setFileName(campaign.file ? campaign.file.filename : '');
      setWrongFormat(false);
      setWrongUrl(false);
      setDateFilter({
        startDate: moment(campaign.startDate),
        endDate: moment(campaign.endDate),
      });
      setCampaignUpdate({
        id: campaign.id,
        title: campaign.title,
        deleteFile: false,
        updateFile: null,
        deleteContent: false,
        updateContent: campaign.content,
        deleteLink: false,
        updateLink: campaign.link,
      });
    }
  }, [campaign, showModal]);

  const onDatesChange = dates => {
    if (campaign.status === CAMPAIGN_STATUS.CREATED) {
      setDateFilter(dates);
    } else {
      setDateFilter({
        startDate,
        endDate: dates.endDate,
      });
    }
  };

  const onFileChange = event => {
    setWrongFormat(false);
    const files = event.target.files;
    if (files) {
      if (IMAGE_MIME_TYPES.includes(files[0].type)) {
        setCampaignUpdate({
          ...campaignUpdate,
          updateFile: files[0],
          deleteFile: false,
        });
        setFileName(files[0].name);
      } else {
        setWrongFormat(true);
      }
    }
  };

  const onDeleteFile = event => {
    event.preventDefault();
    event.stopPropagation();
    setFileName('');
    setCampaignUpdate({
      ...campaignUpdate,
      deleteFile: true,
      updateFile: null,
    });
  };

  const onContentChange = content => {
    if (!content) {
      setCampaignUpdate({
        ...campaignUpdate,
        deleteContent: true,
        updateContent: null,
      });
    } else {
      setCampaignUpdate({
        ...campaignUpdate,
        deleteContent: false,
        updateContent: content.slice(0, MAX_CAMPAIGN_CONTENT_LENGTH),
      });
    }
  };

  const onLinkChange = link => {
    if (!link) {
      setCampaignUpdate({
        ...campaignUpdate,
        deleteLink: true,
        updateLink: null,
      });
    } else {
      setCampaignUpdate({
        ...campaignUpdate,
        deleteLink: false,
        updateLink: link,
      });
    }
  };

  const missingContent = campaignUpdate.deleteContent || (!campaign.content && !campaignUpdate.updateContent);
  const missingFile = campaignUpdate.deleteFile || (!campaign.file && !campaignUpdate.updateFile);
  const missingContentAndFile = missingContent && missingFile;

  const updateCampaign = mutation => {
    setSubmitted(true);
    try {
      if (campaignUpdate.updateLink) {
        new URL(campaignUpdate.updateLink);
      }
      setWrongUrl(false);
    } catch (e) {
      setWrongUrl(true);
      return;
    }
    if (
      !wrongFormat &&
      campaignUpdate.title &&
      !missingContentAndFile
    ) {
      const campaignInput = {
        ...campaignUpdate,
      };
      const startDateUpdateFormatted = moment(startDate).format('YYYY-MM-DD');
      if (campaign.status === CAMPAIGN_STATUS.CREATED && startDateUpdateFormatted !== campaign.startDate) {
        campaignInput.startDate = startDateUpdateFormatted;
      }
      const endDateUpdateFormatted = moment(endDate).format('YYYY-MM-DD');
      if (endDateUpdateFormatted !== campaign.endDate) {
        campaignInput.endDate = endDateUpdateFormatted;
      }
      mutation({variables: {campaignInput}})
        .then(() => {
          changeModalState(false);
        }).catch(err => {
          console.error(err);
        });
    }
  };

  const displayPicture = !campaignUpdate.deleteFile && !campaignUpdate.updateFile && campaign.file;

  const displayDate = date => date ? dateFormatFR({date}) : t('campaignField.noDate');
  const displayCivility = civility => civility ? userT(`civilities.${civility}`) : userT(`dataTable.all`);
  const isOutsideDateRange = day => isBeforeDay(day, moment()) || (startDate && isBeforeDay(moment(startDate).add(2, 'weeks'), day));

  return (
    <Mutation mutation={GRAPHQL_MUTATION_UPDATE_CAMPAIGN}>
      {(mutation, {loading, error}) => {
        return (
          <>
            <Modal
              show={showModal}
              onHide={() => {!loading && changeModalState(false);}}
              size={displayPicture ? 'xl' : 'lg'}>
              <ModalHeader closeButton>
                <ColoredHeader className="info-header">{t('detailCampaign.title', {date: dateFormatFR({date: campaign.createdAt})})}</ColoredHeader>
              </ModalHeader>
              {loading ? (
                <LoadingContainer>
                  <PulseLoader/>
                </LoadingContainer>
              ) : (
                <MargedContainer>
                  <Row className="justify-content-center">
                    <Col lg={12} xl={6}>
                      <Panel title={t('selectUsers')}>
                        <Row>
                          <Col xs={8}>{t('startDate')}</Col>
                          <Col>{displayDate(campaign.filterUserStartDate)}</Col>
                        </Row>
                        <Row>
                          <Col xs={8}>{t('endDate')}</Col>
                          <Col>{displayDate(campaign.filterUserEndDate)}</Col>
                        </Row>
                        <Row>
                          <Col xs={8}>{t('civility')}</Col>
                          <Col>{displayCivility(campaign.filterUserCivility)}</Col>
                        </Row>
                      </Panel>
                    </Col>

                    <Col lg={12} xl={6}>
                      <Panel title={t('reachableClients')}>
                        <Row>
                          <Col xs={8}>{t('total')}</Col>
                          <Col>{campaign.totalUsers}</Col>
                        </Row>
                        <Row>
                          <Col xs={8}>{t('usersWithLoyaltyCard')}</Col>
                          <Col>{campaign.totalUsersWithLoyaltyCard}</Col>
                        </Row>
                        <Row>
                          <Col xs={8}>{t('usersWithoutLoyaltyCard')}</Col>
                          <Col>{campaign.totalUsersWithoutLoyaltyCard}</Col>
                        </Row>
                      </Panel>
                    </Col>

                    <Col lg={12} xl={displayPicture ? 6 : 12}>
                      <Panel title={t('detailCampaign.details')}>

                        <AttributeDiv className="label-name">{`${t('detailCampaign.createdAt')} : `}</AttributeDiv>
                        <Input
                          disabled
                          title={`${t('detailCampaign.createdAt')} : `}
                          name="createdAt"
                          value={dateFormatFR({date: campaign.createdAt})}
                        />

                        <AttributeDiv className="label-name">{`${t('campaignField.campaignDates')} : `}</AttributeDiv>
                        <DateRangePicker
                          startDate={startDate}
                          endDate={endDate}
                          isOutsideRange={isOutsideDateRange}
                          onDatesChange={onDatesChange}
                          disabled={!editable}
                          showClearDates={false}
                        />

                        <AttributeDiv className="label-name">{t('campaignField.campaignTitle')} <small>{t('campaignField.limitCharacters', {limit: MAX_CAMPAIGN_TITLE_LENGTH})}</small> :</AttributeDiv>
                        <Input
                          disabled={!editable}
                          title={`${t('campaignField.title')} : `}
                          name="title"
                          value={campaignUpdate.title ? campaignUpdate.title : ''}
                          onChange={(e) => {e.target.value.length <= MAX_CAMPAIGN_TITLE_LENGTH && setCampaignUpdate({...campaignUpdate, title: e.target.value});}}
                        />
                        <Tooltip show={!campaignUpdate.title && submitted} color="red">
                          {t('campaignField.requiredField')}
                        </Tooltip>

                        <AttributeDiv className="label-name">{t('campaignField.campaignVisual')} <small>{t('campaignField.campaignVisualSize', {width: CAMPAIGN_PICTURE_WIDTH, height: CAMPAIGN_PICTURE_HEIGHT})}</small> :</AttributeDiv>
                        <FileLabel disabled={!editable}>
                          {' '}
                          <FileNameDiv>{fileName}</FileNameDiv>
                          {editable && fileName && (
                            <DeleteLogoButton onClick={onDeleteFile}>
                              <FontAwesomeIcon icon={faTimes} color="red" size="sm" />
                            </DeleteLogoButton>
                          )}
                          <FileDiv>
                            {t('campaignField.browse')}
                          </FileDiv>
                          <FileInput type="file"  accept="image/*" onChange={onFileChange} disabled={!editable}/>
                        </FileLabel>
                        <Tooltip show={wrongFormat} color="red">
                          {t('campaignField.wrongFormat')}
                        </Tooltip>
                        <Tooltip show={missingContentAndFile && submitted} color="red">
                          {t('campaignField.requiredFileIfNoContent')}
                        </Tooltip>

                        <AttributeDiv className="label-name">{t('campaignField.content')} <small>{t('campaignField.limitCharacters', {limit: MAX_CAMPAIGN_CONTENT_LENGTH})}</small> :</AttributeDiv>
                        <Input
                          disabled={!editable}
                          title={`${t('campaignField.content')} : `}
                          name="content"
                          type="textarea"
                          value={campaignUpdate.updateContent ? campaignUpdate.updateContent : ''}
                          onChange={(e) => onContentChange(e.target.value)}
                        />
                        <Tooltip show={missingContentAndFile && submitted} color="red">
                          {t('campaignField.requiredContentIfNoFile')}
                        </Tooltip>

                        <AttributeDiv className="label-name">{`${t('campaignField.linkToCampaign')} : `}</AttributeDiv>
                        <Input
                          disabled={!editable}
                          title={`${t('campaignField.linkToCampaign')} : `}
                          name="link"
                          placeholder="https://..."
                          type="url"
                          value={campaignUpdate.updateLink ? campaignUpdate.updateLink : ''}
                          onChange={(e) => onLinkChange(e.target.value)}
                        />
                        <Tooltip show={wrongURL} color="red">
                          {t('campaignField.wrongUrl')}
                        </Tooltip>

                      </Panel>
                    </Col>

                    {displayPicture && (
                      <Col className="text-center">
                        <Panel title={t('detailCampaign.fileThumbnail')}>
                          <ImageCampaign src={config.api_file_campaign + campaign.id + '?token=' + campaign.file.token}/>
                        </Panel>
                      </Col>
                    )}
                  </Row>

                  {editable && (
                    <FooterRow>
                      <GradientCol sm={{span: 6, offset: 3}}>
                        {(campaignUpdate.updateContent && fileName) && (
                          <MargedAlert color="info">{t('campaignField.campaignVisualAlert')}</MargedAlert>
                        )}
                        {error && (
                          <Error error={t('unknownError')} />
                        )}
                        <div className="popin-buttons">
                          <div>
                            <TitleButton onClick={() => {updateCampaign(mutation);}}>
                              {t('detailCampaign.save')}
                            </TitleButton>
                          </div>
                          <CancelButton style={{marginTop: 0, width: 'auto', height: 'auto'}} onClick={() => changeModalState(false)}>
                            {t('cancel')}
                          </CancelButton>
                        </div>
                      </GradientCol>
                    </FooterRow>
                  )}
                </MargedContainer>
              )}
            </Modal>
          </>
        );
      }}
    </Mutation>
  );
};

CampaignDetailsModal.defaultProps = {
  editable: true,
};

CampaignDetailsModal.propTypes = {
  t: PropTypes.func.isRequired,
  campaign: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    createdAt: PropTypes.string,
    title: PropTypes.string,
    link: PropTypes.string,
    content: PropTypes.string,
    file: PropTypes.object,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
  }).isRequired,
  showModal: PropTypes.bool.isRequired,
  currentUser: PropTypes.shape({
    role: PropTypes.string,
  }),
  changeModalState: PropTypes.func.isRequired,
  editable: PropTypes.bool,
};

export default compose(
  withLoadedUser,
  withTranslation('campaign'),
)(CampaignDetailsModal);
